import { colors } from 'Constants/Colors';
import styled from 'styled-components';

export const FormContainer = styled.div`
  margin: 1rem;
  display: flex;
  flex-direction: column;
`;

export const SelectContainer = styled.div`
  margin: 3vh 0;
`;

export default {
  FormContainer,
  SelectContainer,
};
